/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ESensorDbSensorTypes} from "../../../constants/globalVariables";

const sensorUltrasonicHeaderTitle = "Ultrasonic Database"
const getUltrasonicLandingEndpoint = "/HttpTriggerSensors?req=get&type=ultrasonic-landing"
const addUltrasonicEndpoint = `/HttpTriggerSensors?req=add&type=${ESensorDbSensorTypes.ULTRASONIC}`

const errorMessagesTitle = 'Error & Warning Messages:'
const fileProcessingMessagesTitle = 'File Processing Messages:'

const deleteUltrasonicTempFileEndpoint = "/HttpTriggerSensors?req=delete&type=ultrasonic-temp-file"
const addUltrasonicConfigEndpoint = "/HttpTriggerSensors?req=add&type=ultrasonic-config"
const deleteUltrasonicrConfigEndpoint = "/HttpTriggerSensors?req=delete&type=ultrasonic-config"
const getUltrasonicDetailsEndpoint = "/HttpTriggerSensors?req=get&type=ultrasonic-details"
const getUltrasonicPlotEndpoint = "/HttpTriggerSensors?req=get&type=ultrasonic-plot"
const uploadFileUltrasonicEndpoint = `/HttpTriggerSensors?req=upload-file&type=${ESensorDbSensorTypes.ULTRASONIC}`

export interface Ultrasonic {
  id: string
  type: string
  version: string
  dateCreated: string
  baseline: any
  plotData: any
  configurations: any
  owner: string
  isPublicConfig: string
  radarType: string
  supplier: string
  component: string
  componentVersion: string
  detectionDegradation: number
  maxInstrumentedRange: number
  azimuthFOV: number
  elevationFOV: number
  txPowerHot: number
  singleSideBandNoiseHot: number
  twoWayAntannaGainHot: number
  twoWayRadomeTxLineLossesHot: number
  numTxRxChannels: number
  totalMeasurementCycle: any
  isRxIqOrReal: number
  totalChirpTimePerFrame: number
  txChannelsTransmitSimultaneouslyTdmOrFdm: number
  firingMode: string
}

export {
  errorMessagesTitle,
  fileProcessingMessagesTitle,
  sensorUltrasonicHeaderTitle,
  getUltrasonicLandingEndpoint,
  addUltrasonicEndpoint,
  deleteUltrasonicTempFileEndpoint,
  addUltrasonicConfigEndpoint,
  deleteUltrasonicrConfigEndpoint,
  getUltrasonicDetailsEndpoint,
  getUltrasonicPlotEndpoint,
  uploadFileUltrasonicEndpoint
}